const prefix = "USER"

export const SIGN_IN = `${prefix}_SIGN_IN`